import { Redact, TextLink } from '../../../../core'
import { useApiOrgSlugFromParams } from '../../../utils/orgSlug'
import { EncounterUpdateViolationCodeSchema } from './encounterUpdateViolationCodeSchema'
import { getWorkspaceEncounterHref } from '../utils/workspaceEncounterHrefs'
import { formatEncounterLabel } from '@joyful/utils'
import type { components } from '@joyful/openapi/types.gen'

type EncounterUpdateViolationCode =
  components['schemas']['EncounterUpdateViolationCode']

export interface EncounterUpdateFailureEntry {
  encounter: {
    id: string
    patient_name?: string | null
    start_date?: string | null
  }
  violations: ReadonlyArray<EncounterUpdateViolationCode>
}

interface EncounterUpdateFailuresListProps {
  readonly failures: ReadonlyArray<EncounterUpdateFailureEntry>
}

export function EncounterUpdateFailuresList({
  failures,
}: EncounterUpdateFailuresListProps) {
  const orgSlug = useApiOrgSlugFromParams()
  return (
    <ul className="flex flex-col gap-1.5 text-xs">
      {failures.map((failure) => {
        const { encounter, violations } = failure
        const linkLabel = encounter.patient_name?.trim() ? (
          <Redact>{formatEncounterLabel(encounter)}</Redact>
        ) : (
          encounter.id
        )
        const linkedLabel =
          orgSlug === null ? (
            linkLabel
          ) : (
            <TextLink
              to={getWorkspaceEncounterHref({
                encounterId: encounter.id,
                orgSlug,
              })}
              size="xs"
              aria-label={`View encounter details`}
            >
              {linkLabel}
            </TextLink>
          )

        return (
          <li key={encounter.id} className="flex flex-col gap-1">
            {linkedLabel}
            <ul className="marker:text-tremor-content list-disc pl-6">
              {violations.length > 0 ? (
                violations.map((violation) => {
                  return (
                    <li key={violation}>
                      {EncounterUpdateViolationCodeSchema.meta(violation).title}
                    </li>
                  )
                })
              ) : (
                <li>Unable to update encounter</li>
              )}
            </ul>
          </li>
        )
      })}
    </ul>
  )
}
